const ITEMS = [
  "DOJ Extensions & Stays",
  "Plans of Correction",
  "Plans of Implementation",
  "SAPS Individualized Support",
  "Data Reading & Analysis",
  "100% Compliance Record",
  "Money-Back Guarantee",
];

export default function Marquee() {
  return (
    <section
      className="overflow-hidden border-y border-sand/10 bg-abyss py-6"
      data-testid="editorial-marquee"
      aria-hidden="true"
    >
      <div className="animate-marquee flex w-max">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex shrink-0 items-center">
            {ITEMS.map((item) => (
              <span key={`${copy}-${item}`} className="flex items-center">
                <span className="whitespace-nowrap px-8 font-display text-2xl font-bold uppercase tracking-tight text-sand/15 lg:text-3xl">
                  {item}
                </span>
                <span className="h-2 w-2 shrink-0 rounded-full bg-ochre/50" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
